import { IFilterItem } from "./ifilteritem.model";

export interface IDB_api_filter {
    columns: any[];
    groupby: string;
    filter: string;
}

export interface IDB_filter {
    filter: string;
    value: any;
}

export class DB_filter {
    id_Filter: string;
    items: IFilterItem[];
    value: any[] = [];
    


    /**
     * 
     * @param id_filter 
     * @param values Now is matlistoption, esto hay que cambiarlo
     */
    constructor(id_filter: string, values: any) {
        this.id_Filter = id_filter;
        if (values) {
            for (let elem of values) {
                this.value.push(elem.value);
            }
        }
    }

    config(id_filter: string, values: any ) {
        this.id_Filter = id_filter;
        if (values) {
            for (let elem of values) {
                this.value.push(elem.value);
            }
        }
    }

    static newFilterByArray(filter: string, values: any[]):DB_filter {
        let df=new DB_filter(filter,null);
        if (values) {
            for (let elem of values) {
                df.value.push(elem);
            }
        }
        return df;
    }  
    

}

export interface IDB_Chart_Res {
    field: string;
    count: number;
    filter: IDB_api_filter;
}

/**
 * Supervision status enum
 */
export enum DBColumnsEnum {
    site_id = "site_id",
    id_supervision = "id_supervision",
    issue_type = "issue_type",
    relevance = "relevance",
    panel_model="panel_model",
    panel_brand="panel_brand",
    issue_status="status"
    
}